import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { BaseLoadAllGuard } from '@ideapa/app-base-components';

import { SharedFacade } from '../+state/facade';
import { TipologiaDocumento } from '../+state/models';

@Injectable()
export class LoadAllGuard
  extends BaseLoadAllGuard<TipologiaDocumento>
  implements CanActivate
{
  constructor(sharedFacade: SharedFacade) {
    super(sharedFacade);
  }
}
